/**
 * @generated SignedSource<<9825297165de62892d5a4b92c98d0aad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PipelineAccessLevels = "BUILD_AND_READ" | "MANAGE_BUILD_AND_READ" | "READ_ONLY" | "%future added value";
export type TeamPipelineUpdateInput = {
  accessLevel: PipelineAccessLevels;
  clientMutationId?: string | null;
  id: string;
};
export type PipelinesTeamAccessLevelChangeMutation$variables = {
  input: TeamPipelineUpdateInput;
};
export type PipelinesTeamAccessLevelChangeMutation$data = {
  readonly teamPipelineUpdate: {
    readonly teamPipeline: {
      readonly accessLevel: PipelineAccessLevels;
    };
  } | null;
};
export type PipelinesTeamAccessLevelChangeMutation = {
  response: PipelinesTeamAccessLevelChangeMutation$data;
  variables: PipelinesTeamAccessLevelChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessLevel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamPipelineUpdatePayload",
        "kind": "LinkedField",
        "name": "teamPipelineUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipeline",
            "kind": "LinkedField",
            "name": "teamPipeline",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelinesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamPipelineUpdatePayload",
        "kind": "LinkedField",
        "name": "teamPipelineUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipeline",
            "kind": "LinkedField",
            "name": "teamPipeline",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39b130d5aad8d9966ead7cf861a0e87f",
    "id": null,
    "metadata": {},
    "name": "PipelinesTeamAccessLevelChangeMutation",
    "operationKind": "mutation",
    "text": "mutation PipelinesTeamAccessLevelChangeMutation(\n  $input: TeamPipelineUpdateInput!\n) {\n  teamPipelineUpdate(input: $input) {\n    teamPipeline {\n      accessLevel\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b77e06d206ef48b6582ff8e9ab7f146b";

export default node;
